import { useEffect, useState } from "react";

export function useCountdown(endsAt: number | null): number {
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  useEffect(() => {
    if (endsAt === null) {
      setRemainingSeconds(0);
      return;
    }

    const tick = () => {
      setRemainingSeconds(Math.max(0, Math.ceil((endsAt - Date.now()) / 1000)));
    };

    tick();
    const interval = setInterval(tick, 250);
    return () => clearInterval(interval);
  }, [endsAt]);

  return remainingSeconds;
}
